import React,{useState,useEffect,useRef} from 'react'
import styled from 'styled-components'

export default React.memo(()=>{
    const [index, setIndex] = useState(0)
    const [width, setWidth] = useState(0)
    const [loaded, setLoaded] = useState(false)
    
    const iFrameRef = useRef(null)
    const videoIDs = [
        '73mmiSCVPvo',
        'rYhZzDVa7H0',
        'VOlSA4PcQ6Y'
    ]


    useEffect(()=>{
        document.addEventListener('scroll',function scrollLoadHandler(){
            if(loaded) return 
            if(window.scrollY>1000){
                setLoaded(true)
                document.removeEventListener('scroll',scrollLoadHandler)
            }
        })
        setWidth(window.innerWidth/2 > 400 ? window.innerWidth/2 : window.innerWidth - document.getElementById('side-bar').offsetWidth)
    },[])

    window.addEventListener('resize',e=>{
        setWidth(window.innerWidth/2 > 400 ? window.innerWidth/2 : window.innerWidth - document.getElementById('side-bar').offsetWidth)
    })

  
    
    function changeLink(arg){
        if(arg=='inc'){
            let i = index + 1
            if(!videoIDs[i]) setIndex(0)
            else setIndex(i)
        }else if(arg=='dec'){
            let i = index - 1
            if(!videoIDs[i]) setIndex(videoIDs.length-1)
            else setIndex(i)
        }  
    }

    const ButtonContainer = styled.div`
        display:flex;
        background:rgb(40,40,40);
        color:rgba(220,220,220);
        width:${width}px;
        margin:auto;
        justify-content:space-between;

        & button{
            font-family:inherit;
            font-size:1rem;
            padding:1rem 2rem;
            border:none;
            background:rgb(150,20,20);
            color:white;
            cursor:pointer;
            transition:0.2s;

            &:hover{
                opacity:0.6;
            }
        }
    `

    const VideoContainer = styled.div`
        overflow:hidden;
        border-bottom-left-radius:5px;
        border-bottom-right-radius:5px;
        width:max-content;
        margin:auto;
        height:auto;
        box-shadow:2px 2px 8px black;
        background:black;
    `

    return(
        <React.Fragment>

            {loaded && <React.Fragment>
                <iframe loading="lazy" src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fexaltedchristianband%2Fvideos%2F2309436192635097%2F&show_text=false&width=560" style={{display:'block',margin:'auto', boxShadow:"2px 2px 8px black", marginBottom:"4rem"}} width={width} height={width/1.8} scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
            <VideoContainer>
                
                <iframe loading="lazy" ref={iFrameRef} style={{display:'block',margin:'auto'}} width={width} height={width/1.8} src={'https://www.youtube.com/embed/'+videoIDs[index]} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <ButtonContainer>
                    <button onClick={()=>changeLink('dec')} >Back</button>  <button onClick={()=>changeLink('inc')} >Next</button> 
                </ButtonContainer>
            </VideoContainer>
            </React.Fragment>}
            
        </React.Fragment>
    )
})